import type { AdminPermissions } from '@business-game/shared';
import type { AdminAuthUser } from '../services/api/auth.api';

const SECTION_VIEW_ACTION: Partial<Record<keyof AdminPermissions['sections'], keyof AdminPermissions['actions']>> = {
  sessions: 'sessionsView',
  programs: 'programsView',
};

export const canSeeAdminSection = (
  user: AdminAuthUser | null | undefined,
  section: keyof AdminPermissions['sections']
): boolean => {
  if (!user?.permissions.sections[section]) return false;

  const viewAction = SECTION_VIEW_ACTION[section];
  if (viewAction) {
    return user.permissions.actions[viewAction] === true;
  }

  return true;
};

export const canPerformAdminAction = (
  user: AdminAuthUser | null | undefined,
  action: keyof AdminPermissions['actions']
): boolean => !!user?.permissions.actions[action];
